!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("prop-types")) : "function" == typeof define && define.amd ? define("SpicyDatatable", ["react", "prop-types"], t) : "object" == typeof exports ? exports.SpicyDatatable = t(require("react"), require("prop-types")) : e.SpicyDatatable = t(e.React, e.PropTypes);
}(this, function (e, t) {
  return function (e) {
    function t(a) {
      if (n[a]) return n[a].exports;
      var r = n[a] = {
        i: a,
        l: !1,
        exports: {}
      };
      return e[a].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.i = function (e) {
      return e;
    }, t.d = function (e, n, a) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: a
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 9);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SpicyDatatablePropTypes = t.DatatableRowsPropTypes = t.DatatableHeaderPropTypes = t.Header = t.Rows = t.DatatableSearchBarPropTypes = t.DatatablePageSizePickerPropTypes = t.DatatableOptionsPropTypes = void 0;

    var a = n(15),
        r = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(a),
        o = (t.DatatableOptionsPropTypes = {
      itemsPerPage: r.default.number.isRequired,
      searchValue: r.default.string.isRequired,
      onSearch: r.default.func.isRequired,
      onPageSizeChange: r.default.func.isRequired,
      itemsPerPageOptions: r.default.arrayOf(r.default.number),
      itemsPerPageLabel: r.default.string,
      searchLabel: r.default.string,
      searchPlaceholder: r.default.string,
      onDownloadCSV: r.default.func,
      showDownloadCSVButton: r.default.bool,
      downloadCSVButtonLabel: r.default.string
    }, t.DatatablePageSizePickerPropTypes = {
      label: r.default.string.isRequired,
      onChange: r.default.func.isRequired,
      value: r.default.number.isRequired,
      options: r.default.arrayOf(r.default.number).isRequired
    }, t.DatatableSearchBarPropTypes = {
      label: r.default.string.isRequired,
      onChange: r.default.func.isRequired,
      value: r.default.number.isRequired,
      placeholder: r.default.string.isRequired
    }, t.Rows = r.default.array.isRequired),
        i = t.Header = r.default.shape({
      key: r.default.string.isRequired,
      label: r.default.string.isRequired
    }),
        l = t.DatatableHeaderPropTypes = r.default.arrayOf(i).isRequired;

    t.DatatableRowsPropTypes = r.default.shape({
      columns: i,
      rows: o
    }).isRequired, t.SpicyDatatablePropTypes = {
      tableKey: r.default.string.isRequired,
      columns: l,
      rows: o,
      config: r.default.shape({
        itemsPerPageOptions: r.default.arrayOf(r.default.number),
        itemsPerPageLabel: r.default.string,
        nextPageLabel: r.default.string,
        previousPageLabel: r.default.string,
        searchLabel: r.default.string,
        searchPlaceholder: r.default.string,
        noEntriesLabel: r.default.string,
        entryCountLabels: r.default.arrayOf(r.default.string),
        customFilter: r.default.func,
        showDownloadCSVButton: r.default.bool,
        downloadCSVButtonLabel: r.default.string,
        customCSVKeys: r.default.arrayOf(r.default.string),
        customCSVRowsFormatter: r.default.func
      })
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.DatatableOptionsDefaults = {
      pageSizeOptions: [10, 25, 50, 100],
      itemsPerPageLabel: "Entries per page:",
      searchLabel: "Search:",
      searchPlaceholder: "Type to search…",
      downloadCSVButtonLabel: "Export CSV"
    }, t.PaginationDefaults = {
      maxButtons: 7,
      nextLabel: "Next",
      previousLabel: "Back"
    }, t.SpicyDatatableDefaults = {
      noEntiresLabel: "No entries to show.",
      entryCountLabels: ["Showing", "to", "of", "entries."]
    };
  }, function (e, t, n) {
    "use strict";

    function a(e, t) {
      return e[t] ? e[t] : u;
    }

    function r(e, t, n, a) {
      void 0 === e[t] && (e[t] = {}), e[t][n] = a;
    }

    function o(e, t) {
      var n = 0,
          a = 0,
          r = [];
      t ? (n = t, a = e) : (a = 0, n = e);

      for (var o = a; o < n; o++) {
        r.push(o);
      }

      return r;
    }

    function i(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
          a = [];
      return null === n || "" === n ? e : (e.forEach(function (e) {
        t.some(function (t) {
          if (void 0 !== e[t.key] && null !== e[t.key]) {
            var r = String(e[t.key]).toLowerCase();
            if (r.length >= n.length && r.indexOf(n.toLowerCase()) >= 0) return a.push(e), !0;
          }

          return !1;
        });
      }), a);
    }

    function l(e, t) {
      var n = function n(e) {
        return "string" == typeof e ? e.toLowerCase() : e;
      },
          a = function a(t) {
        return n ? n(t[e]) : t[e];
      },
          r = function r(e, n) {
        return (e < n ? -1 : e > n ? 1 : 0) * [-1, 1][Number(Boolean(t))];
      };

      return function (e, t) {
        return r(a(e), a(t));
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getSafely = a, t.setSafely = r, t.range = o, t.filterRows = i, t.sortBy = l;
    var u = t.defaultCache = {
      searchQuery: ""
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(0),
        r = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(a),
        o = n(1),
        i = function i(e) {
      var t = e.columns,
          n = e.onSort,
          a = e.sort;
      return r.default.createElement("thead", null, r.default.createElement("tr", null, t.map(function (e) {
        return r.default.createElement("th", {
          key: e.key,
          onClick: e.sort ? function (t) {
            return n(t, e);
          } : void 0,
          style: {
            cursor: e.sort ? "pointer" : "default"
          }
        }, a.sortColumn === e.key ? r.default.createElement("span", {
          style: {
            fontSize: "0.6rem"
          }
        }, a.sortOrder ? "▼ " : "▲ ") : "", e.label);
      })));
    };

    i.propTypes = o.DatatableHeaderPropTypes, t.default = i;
  }, function (e, t, n) {
    "use strict";

    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var a = t[n];
          a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
      }

      return function (t, n, a) {
        return n && e(t.prototype, n), a && e(t, a), t;
      };
    }(),
        u = n(0),
        s = a(u),
        c = n(10),
        f = a(c),
        p = n(11),
        d = a(p),
        h = n(1),
        y = n(2),
        b = function (e) {
      function t() {
        return r(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return i(t, e), l(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.itemsPerPage,
              n = e.itemsPerPageLabel,
              a = e.itemsPerPageOptions,
              r = e.onPageSizeChange,
              o = e.onSearch,
              i = e.searchValue,
              l = e.searchLabel,
              u = e.searchPlaceholder,
              c = e.onDownloadCSV,
              p = e.showDownloadCSVButton,
              h = e.downloadCSVButtonLabel,
              b = a || y.DatatableOptionsDefaults.pageSizeOptions;
          return s.default.createElement("div", {
            className: "spicy-datatableoptions-wrapper"
          }, s.default.createElement("div", null, (0, f.default)({
            label: n || y.DatatableOptionsDefaults.itemsPerPageLabel,
            onChange: r,
            value: t,
            options: b
          }), (0, d.default)({
            label: l || y.DatatableOptionsDefaults.searchLabel,
            value: i,
            onChange: o,
            placeholder: u || y.DatatableOptionsDefaults.searchPlaceholder
          })), p ? s.default.createElement("div", {
            className: "spicy-datatableoptions-export--button-wrapper"
          }, s.default.createElement("button", {
            className: "spicy-datatableoptions-export--button",
            onClick: c
          }, h || y.DatatableOptionsDefaults.downloadCSVButtonLabel)) : null);
        }
      }]), t;
    }(u.Component);

    b.propTypes = h.DatatableOptionsPropTypes, t.default = b;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(0),
        r = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(a),
        o = n(1),
        i = function i(e) {
      var t = e.columns;
      return e.rows.map(function (e, n) {
        return r.default.createElement("tr", {
          key: n,
          onClick: e.onClickHandler ? function (t) {
            return e.onClickHandler(t, e, n);
          } : function () {},
          style: {
            cursor: e.onClickHandler ? "pointer" : "default"
          },
          className: e.isActive ? "spicy-datatable--selected-row" : ""
        }, t.map(function (t, n) {
          return r.default.createElement("td", {
            key: n
          }, e[t.key]);
        }));
      });
    };

    i.propTypes = o.DatatableRowsPropTypes, t.default = i;
  }, function (e, t, n) {
    "use strict";

    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var a = t[n];
          a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
      }

      return function (t, n, a) {
        return n && e(t.prototype, n), a && e(t, a), t;
      };
    }(),
        u = n(0),
        s = a(u),
        c = n(12),
        f = a(c),
        p = n(13),
        d = n(2),
        h = function (e) {
      function t() {
        return r(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return i(t, e), l(t, [{
        key: "renderPagination",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.itemsPerPage,
              a = t.total,
              r = t.activePage,
              o = t.nextPageLabel,
              i = t.previousPageLabel,
              l = Math.ceil(a / (n || 1)),
              u = 1 === r ? 1 : r - 1,
              c = r === l ? l : r + 1,
              h = [(0, f.default)("previous", this.handlePageButtonClick.bind(this, u), i || d.PaginationDefaults.previousLabel)],
              y = (0, p.getPaginationButtons)(d.PaginationDefaults.maxButtons, r, l).map(function (t, n) {
            var a = "spicy-datatable-pagination-button " + (t + 1 === r ? "active" : "");
            return "ellipsis" === t ? s.default.createElement("li", {
              key: "ellipsis" + n,
              className: "spicy-datatable-pagination-button spicy-datatable-pagination-button-elipsis"
            }, "…") : s.default.createElement("li", {
              key: t + 1,
              className: a,
              onClick: e.handlePageButtonClick.bind(e, t + 1)
            }, s.default.createElement("span", null, t + 1));
          });
          return h = h.concat(y), h.push((0, f.default)("next", this.handlePageButtonClick.bind(this, c), o || d.PaginationDefaults.nextLabel)), h;
        }
      }, {
        key: "handlePageButtonClick",
        value: function value(e) {
          var t = this.props.onPage;
          t && t(e);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.renderPagination();
          return s.default.createElement("div", {
            className: "spicy-datatable-pagination-root"
          }, s.default.createElement("ul", {
            className: "spicy-datatable-pagination-list",
            style: {
              float: "right"
            }
          }, e));
        }
      }]), t;
    }(u.Component);

    t.default = h;
  }, function (e, t, n) {
    "use strict";

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var a = t[n];
          a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
      }

      return function (t, n, a) {
        return n && e(t.prototype, n), a && e(t, a), t;
      };
    }(),
        o = n(14),
        i = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(o),
        l = function () {
      function e(t) {
        a(this, e), this.options = t || {};
      }

      return r(e, [{
        key: "createCSVBlob",
        value: function value(e) {
          return this.createCSV(e);
        }
      }, {
        key: "dataToString",
        value: function value(e) {
          return this.createCSV(e, "string");
        }
      }, {
        key: "createCSV",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "blob",
              n = this.options || {},
              a = n.columns,
              r = n.contentType,
              o = n.delimeter,
              l = n.formatters,
              u = n.headers,
              s = n.includeHeaders,
              c = r || "text/csv",
              f = o || ",",
              p = l || {},
              d = function d(e) {
            return p[e] || function (e) {
              return e;
            };
          },
              h = u || {},
              y = a || Object.getOwnPropertyNames(e[0]),
              b = s,
              g = new i.default(f, c);

          return (void 0 === b || b) && (y.forEach(function (e) {
            return g.writeValue(h[e] || e);
          }), g.writeLine()), e.forEach(function (e) {
            y.forEach(function (t) {
              return g.writeValue(d(t)(e[t]));
            }), g.writeLine();
          }), "string" === t ? g.toString() : g.toBlob();
        }
      }, {
        key: "download",
        value: function value(e, t) {
          if (navigator.msSaveBlob) return void navigator.msSaveBlob(e, t);
          var n = document.createElement("A"),
              a = URL.createObjectURL(e);
          n.href = a, n.download = t, n.style.display = "none", document.body.appendChild(n), n.click(), document.body.removeChild(n);
        }
      }, {
        key: "downloadCSV",
        value: function value(e) {
          try {
            var t = this.createCSV(e, "blob"),
                n = this.options.filename || "export-" + (new Date().getTime() / 1e3 | 0) + ".csv";
            this.download(t, n);
          } catch (e) {
            this.options.devMode && console.error("Error downloading CSV. Send this log to the developers: \n", e), this.options.onError && this.options.onError(e);
          }
        }
      }], [{
        key: "create",
        value: function value(t) {
          return new e(t);
        }
      }, {
        key: "download",
        value: function value(t) {
          return new e(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).downloadCSV(t);
        }
      }]), e;
    }();

    t.default = l;
  }, function (e, t, n) {
    "use strict";

    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function l(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var u = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var a = t[n];
          a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
      }

      return function (t, n, a) {
        return n && e(t.prototype, n), a && e(t, a), t;
      };
    }(),
        s = n(0),
        c = a(s),
        f = n(8),
        p = a(f),
        d = n(5),
        h = a(d),
        y = n(4),
        b = a(y),
        g = n(6),
        m = a(g),
        P = n(7),
        v = a(P),
        w = n(1),
        S = n(3),
        C = n(2),
        O = {},
        _ = function (e) {
      function t(e) {
        o(this, t);
        var n = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        k.call(n);
        var a = (0, S.getSafely)(O, e.tableKey).itemsPerPage || (e.config && e.config.itemsPerPageOptions ? e.config.itemsPerPageOptions[0] : 10);

        if (n.state = {
          itemsPerPage: a,
          currentPage: (0, S.getSafely)(O, e.tableKey).currentPage || 1,
          searchQuery: (0, S.getSafely)(O, e.tableKey).searchQuery || "",
          sortColumn: !1,
          sortOrder: !1
        }, n.state.searchQuery.length > 0) {
          var r = e.customFilter ? e.customFilter : S.filterRows,
              l = r(e.rows, e.columns, n.state.searchQuery) || [];
          n.setState({
            filteredRows: l
          });
        }

        return n;
      }

      return l(t, e), u(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.columns,
              n = e.rows,
              a = void 0 === n ? [] : n,
              r = e.config,
              o = void 0 === r ? {} : r,
              i = this.state || {},
              l = i.itemsPerPage,
              u = i.currentPage,
              s = i.searchQuery,
              f = void 0 === s ? "" : s,
              p = i.filteredRows,
              d = void 0 === p ? [] : p,
              y = o.itemsPerPageOptions,
              g = o.itemsPerPageLabel,
              P = o.nextPageLabel,
              w = o.previousPageLabel,
              S = o.searchLabel,
              O = o.searchPlaceholder,
              _ = o.noEntriesLabel,
              k = o.entryCountLabels,
              D = o.showDownloadCSVButton,
              E = o.downloadCSVButtonLabel,
              L = f.length > 0,
              V = L ? d : a,
              j = u * l,
              R = V && V.length > 0 ? V.slice((u - 1) * l, j) : [],
              T = L ? V.length : a.length,
              x = (u - 1) * l + 1,
              B = j > T ? T : j,
              M = k || C.SpicyDatatableDefaults.entryCountLabels;
          return c.default.createElement("div", null, c.default.createElement(h.default, {
            itemsPerPage: l,
            itemsPerPageOptions: y,
            itemsPerPageLabel: g,
            onPageSizeChange: this.handlePageSizeChange,
            onSearch: this.handleSearchQueryChange,
            searchValue: f,
            searchLabel: S,
            searchPlaceholder: O,
            showDownloadCSVButton: D,
            downloadCSVButtonLabel: E,
            onDownloadCSV: this.handleDownloadCSV.bind(this, V)
          }), c.default.createElement("table", {
            className: "spicy-datatable"
          }, (0, b.default)({
            sort: {
              sortColumn: this.state.sortColumn,
              sortOrder: this.state.sortOrder
            },
            columns: t,
            onSort: this.handleSort
          }), c.default.createElement("tbody", null, (0, m.default)({
            columns: t,
            rows: R
          }))), c.default.createElement("div", {
            className: "spicy-datatable-counter"
          }, T > 0 ? c.default.createElement("p", null, M[0], " ", x, " ", M[1], " ", B, " ", M[2], " ", T, " ", M[3]) : c.default.createElement("p", null, _ || C.SpicyDatatableDefaults.noEntiresLabel)), c.default.createElement(v.default, {
            onPage: this.handlePagination,
            itemsPerPage: l,
            total: T,
            activePage: u,
            nextPageLabel: P,
            previousPageLabel: w
          }));
        }
      }]), t;
    }(s.Component),
        k = function k() {
      var e = this;
      this.componentWillUnmount = function () {
        clearTimeout(e.scheduleQueryChange);
      }, this.componentDidUpdate = function (t, n) {
        if (t.tableKey !== e.props.tableKey) {
          var a = (0, S.getSafely)(O, e.props.tableKey).itemsPerPage || (e.props.config && e.props.config.itemsPerPageOptions ? e.props.config.itemsPerPageOptions[0] : 10),
              r = (0, S.getSafely)(O, e.props.tableKey).currentPage || 1;
          e.setState({
            currentPage: r,
            itemsPerPage: a
          });
        }
      }, this.handlePagination = function (t) {
        var n = e.props.tableKey;
        e.setState({
          currentPage: t
        }), (0, S.setSafely)(O, n, "currentPage", t);
      }, this.handleSort = function (t, n) {
        var a = e.props.rows,
            r = n.key,
            o = e.props.tableKey,
            i = e.state,
            l = i.filteredRows,
            u = i.sortColumn,
            s = i.sortOrder;
        e.scheduleQueryChange && clearTimeout(e.scheduleQueryChange), e.scheduleQueryChange = setTimeout(function () {
          var t = void 0 !== l && l.length > 0 ? l : a,
              n = void 0 === u || !s || String(u).toLowerCase() !== String(r).toLowerCase(),
              i = (0 === r.length ? [] : function () {
            return t.sort((0, S.sortBy)(r, n));
          }()) || [];
          e.setState({
            filteredRows: i,
            currentPage: 1,
            sortColumn: r,
            sortOrder: n
          }), (0, S.setSafely)(O, o, "sortColumn", r), (0, S.setSafely)(O, o, "sortOrder", n), (0, S.setSafely)(O, o, "currentPage", 1);
        }, 200);
      }, this.handleSearchQueryChange = function (t) {
        var n = e.props,
            a = n.columns,
            r = n.rows,
            o = n.config,
            i = void 0 === o ? {} : o,
            l = t.target.value,
            u = e.props.tableKey,
            s = i.customFilter;
        e.scheduleQueryChange && clearTimeout(e.scheduleQueryChange), e.scheduleQueryChange = setTimeout(function () {
          var t = s || S.filterRows,
              n = (0 === l.length ? [] : t(r, a, l)) || [];
          e.setState({
            filteredRows: n,
            searchQuery: l,
            currentPage: 1
          }), (0, S.setSafely)(O, u, "searchQuery", l), (0, S.setSafely)(O, u, "currentPage", 1);
        }, 200);
      }, this.handlePageSizeChange = function (t) {
        var n = t.target.value,
            a = e.props.tableKey;
        e.setState({
          itemsPerPage: Number(n),
          currentPage: 1
        }), (0, S.setSafely)(O, a, "itemsPerPage", Number(n)), (0, S.setSafely)(O, a, "currentPage", 1);
      }, this.formatRowsForCSVDownload = function (t) {
        return e.props.config.customCSVRowsFormatter ? e.props.config.customCSVRowsFormatter(t) : t;
      }, this.filterApplicableKeysForCSVDownload = function () {
        if (e.props.config.customCSVKeys) {
          var t = [];
          return e.props.config.customCSVKeys.map(function (n) {
            e.props.columns.filter(function (e) {
              return n === e.key ? t.push(e) : "";
            });
          }), t;
        }

        return e.props.columns;
      }, this.handleDownloadCSV = function (t) {
        var n = e.filterApplicableKeysForCSVDownload();
        new p.default({
          columns: n.map(function (e) {
            return e.key;
          }),
          headers: n.reduce(function (e, t) {
            return Object.assign({}, e, r({}, t.key, t.label));
          }, {})
        }).downloadCSV(e.formatRowsForCSVDownload(t));
      };
    };

    _.propTypes = w.SpicyDatatablePropTypes, t.default = _;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(0),
        r = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(a),
        o = n(1),
        i = function i(e) {
      var t = e.label,
          n = e.onChange,
          a = e.value,
          o = e.options;
      return r.default.createElement("div", {
        className: "spicy-datatableoptions-sizepicker"
      }, t, r.default.createElement("select", {
        onChange: n,
        value: a,
        className: "spicy-datatableoptions-sizepicker--selectfield"
      }, o.map(function (e, t) {
        return r.default.createElement("option", {
          key: "select-" + e + "-{i}",
          value: e
        }, e);
      })));
    };

    i.propTypes = o.DatatablePageSizePickerPropTypes, t.default = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(0),
        r = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(a),
        o = n(1),
        i = function i(e) {
      var t = e.label,
          n = e.onChange,
          a = e.value,
          o = e.placeholder;
      return r.default.createElement("div", {
        className: "spicy-datatableoptions-search"
      }, r.default.createElement("label", {
        className: "spicy-datatableoptions-search--label"
      }, t, r.default.createElement("input", {
        className: "spicy-datatableoptions-search--input",
        type: "text",
        onChange: n,
        defaultValue: a,
        placeholder: o
      })));
    };

    i.propTypes = o.DatatableSearchBarPropTypes, t.default = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(0),
        r = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(a);

    t.default = function (e, t, n) {
      return r.default.createElement("li", {
        key: e,
        className: "spicy-datatable-pagination-button " + e,
        onClick: t
      }, n);
    };
  }, function (e, t, n) {
    "use strict";

    function a(e, t, n) {
      var a = [],
          o = Math.floor(e / 2);
      return n <= e ? a = (0, r.range)(0, n) : t <= o ? (a = (0, r.range)(0, e - 2), a.push("ellipsis"), a.push(n - 1)) : t >= n - 1 - o ? (a = (0, r.range)(n - (e - 2), n), a.unshift("ellipsis"), a.unshift(0)) : (a = (0, r.range)(t - o + 2, t + o - 1), a.push("ellipsis"), a.push(n - 1), a.unshift("ellipsis"), a.unshift(0)), a;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getPaginationButtons = a;
    var r = n(3);
  }, function (e, t, n) {
    "use strict";

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var a = t[n];
          a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
      }

      return function (t, n, a) {
        return n && e(t.prototype, n), a && e(t, a), t;
      };
    }(),
        o = function () {
      function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ",",
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "text/csv";
        a(this, e), this.delimiter = t, this.contentType = n, this.rows = [[]];
      }

      return r(e, [{
        key: "wrapWithQuotes",
        value: function value(e) {
          return '"' + e.replace(/"/g, '""') + '"';
        }
      }, {
        key: "sanitizeValue",
        value: function value(e) {
          return void 0 === e || null === e || "function" == typeof e ? "" : String(e);
        }
      }, {
        key: "writeValue",
        value: function value(e) {
          var t = this.sanitizeValue(e),
              n = -1 !== t.indexOf(this.delimiter) || /"\r\n/.test(t);
          this.currentRow.push(n ? this.wrapWithQuotes(t) : t);
        }
      }, {
        key: "writeLine",
        value: function value() {
          this.rows.push([]);
        }
      }, {
        key: "toString",
        value: function value() {
          var e = this;
          return this.rows.map(function (t) {
            return t.join(e.delimiter);
          }).reduce(function (e, t) {
            return e + "\r\n" + t;
          });
        }
      }, {
        key: "toBlob",
        value: function value() {
          return new Blob([this.toString()], {
            type: this.contentType
          });
        }
      }, {
        key: "currentRow",
        get: function get() {
          return this.rows[this.rows.length - 1];
        }
      }]), e;
    }();

    t.default = o;
  }, function (e, n) {
    e.exports = t;
  }]);
});